<div class="po-xl-6 po-lg-6 po-md-12 po-sm-12 billing-day" id="billing-day">
  <po-widget>
    <span class="po-font-text-bold title">Percentual médio faturado</span>
    <span class="po-ml-1 po-icon po-icon-xml pointer-cursor" *ngIf="!loading && !errorApi" (click)="downloadExcel()"></span>
    <div class="icon-loading" *ngIf="loading && !errorApi" style="height: 330px; padding-left: 50%; padding-top: 28%;">
      <app-loading-icon></app-loading-icon>
    </div>
    <div *ngIf="!loading && errorApi">
      <app-error [message]="message"></app-error>
    </div>
    <div class="po-row" *ngIf="!loading && !errorApi">
      <div class="po-xl-4 po-lg-4 po-md-4 po-sm-6">
        <div class="po-text-center title-billing-day-monday">
          <span class="po-font-text-bold">Segunda</span>
        </div>
        <div class="po-text-center value-billing-day-monday">
          <div>
            <span class="po-font-subtitle">{{ percentage[1].percentage }}</span>
            <span class="po-font-subtitle po-font-text-small">%</span>
          </div>
        </div>
      </div>
      <div class="po-xl-4 po-lg-4 po-md-4 po-sm-6">
        <div class="po-text-center title-billing-day-tuesday">
          <span class="po-font-text-bold">Terça</span>
        </div>
        <div class="po-text-center value-billing-day-tuesday">
          <div>
            <span class="po-font-subtitle">{{ percentage[2].percentage }}</span>
            <span class="po-font-subtitle po-font-text-small">%</span>
          </div>
        </div>
      </div>
      <div class="po-xl-4 po-lg-4 po-md-4 po-sm-6">
        <div class="po-text-center title-billing-day-wednesday">
          <span class="po-font-text-bold">Quarta</span>
        </div>
        <div class="po-text-center value-billing-day-wednesday">
          <div>
            <span class="po-font-subtitle">{{ percentage[3].percentage }}</span>
            <span class="po-font-subtitle po-font-text-small">%</span>
          </div>
        </div>
      </div>
      <div class="po-xl-4 po-lg-4 po-md-4 po-sm-6">
        <div class="po-text-center title-billing-day-thursday">
          <span class="po-font-text-bold">Quinta</span>
        </div>
        <div class="po-text-center value-billing-day-thursday">
          <div>
            <span class="po-font-subtitle">{{ percentage[4].percentage }}</span>
            <span class="po-font-subtitle po-font-text-small">%</span>
          </div>
        </div>
      </div>
      <div class="po-xl-4 po-lg-4 po-md-4 po-sm-6">
        <div class="po-text-center title-billing-day-friday">
          <span class="po-font-text-bold">Sexta</span>
        </div>
        <div class="po-text-center value-billing-day-friday">
          <div>
            <span class="po-font-subtitle">{{ percentage[5].percentage }}</span>
            <span class="po-font-subtitle po-font-text-small">%</span>
          </div>
        </div>
      </div>
      <div class="po-xl-4 po-lg-4 po-md-4 po-sm-6">
        <div class="po-text-center title-billing-day-saturday">
          <span class="po-font-text-bold">Sábado</span>
        </div>
        <div class="po-text-center value-billing-day-saturday">
          <div>
            <span class="po-font-subtitle">{{ percentage[6].percentage }}</span>
            <span class="po-font-subtitle po-font-text-small">%</span>
          </div>
        </div>
      </div>
      <div class="po-xl-4 po-lg-4 po-md-4 po-sm-6">
        <div class="po-text-center title-billing-day-sunday">
          <span class="po-font-text-bold">Domingo</span>
        </div>
        <div class="po-text-center value-billing-day-sunday">
          <div>
            <span class="po-font-subtitle">{{ percentage[0].percentage }}</span>
            <span class="po-font-subtitle po-font-text-small">%</span>
          </div>
        </div>
      </div>
    </div>
  </po-widget>
</div>